import type * as React from 'react';

import { Separator } from '@gitbook/spine-react';

import { ChangeRequestChanges, type ChangeRequestChangesProps } from '../Changes';
import {
    ChangeRequestCommentsProvider,
    type ChangeRequestCommentsProviderProps,
} from './ChangeRequestCommentsProvider';
import { ChangeRequestDetails } from './ChangeRequestDetails';
import { ChangeRequestIntro, type ChangeRequestIntroProps } from './ChangeRequestIntro';

export type ChangeRequestOverviewProps = ChangeRequestCommentsProviderProps &
    Omit<ChangeRequestIntroProps, 'className'> &
    ChangeRequestChangesProps;

/**
 * Renders the change request overview.
 */
export function ChangeRequestOverview(props: ChangeRequestOverviewProps): React.ReactElement {
    return (
        <ChangeRequestCommentsProvider {...props}>
            <div
                data-comments-boundary=""
                className="@container flex flex-1 overflow-y-auto overflow-x-hidden"
            >
                <div className="flex flex-1 flex-col overflow-y-auto pb-6">
                    <ChangeRequestIntro {...props} className="mx-auto w-full max-w-4xl" />
                    <Separator className="mt-2 mb-0" />
                    <div className="mx-auto flex w-full max-w-4xl px-6">
                        <ChangeRequestChanges {...props} />
                    </div>
                </div>
                <ChangeRequestDetails {...props} />
            </div>
        </ChangeRequestCommentsProvider>
    );
}
